import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingStockTransfer';

const PendingStockTransfer = () => ((orgContainer(InnerComponent)));

export default PendingStockTransfer;
